import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { colors } from 'styles/colors';

const useStyles = makeStyles((theme: Theme) => ({
  valueContainer: {
    backgroundColor: colors.background,
    minHeight: 55,
    borderRadius: 14,
    justifyContent: 'center',
    paddingLeft: 20
  }

}));

export default useStyles;
